(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9a2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9a2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cs7FV", function(module, exports) {
const $910e0db584f0bbf3$var$mobileMenuOverlay = document.querySelector(".overlay");
const $910e0db584f0bbf3$var$hamburgerBtn = document.querySelector(".button-hamburger");
const $910e0db584f0bbf3$var$mobileMenu = document.querySelector(".mobile-menu-container");
const $910e0db584f0bbf3$var$mobileMenuBackBtn = $910e0db584f0bbf3$var$mobileMenu.querySelector(".mobile-menu-back-btn");
const $910e0db584f0bbf3$var$mobileNavMenu = $910e0db584f0bbf3$var$mobileMenu.querySelector(".mobile-nav-menu");
const $910e0db584f0bbf3$var$slideMenu = $910e0db584f0bbf3$var$mobileMenu.querySelector(".mobile-nav-menu-list");
const $910e0db584f0bbf3$var$body = document.querySelector("body");
let $910e0db584f0bbf3$var$activeSubmenu;
function $910e0db584f0bbf3$var$classListToggler(element, className) {
    element.classList.toggle(className);
}
function $910e0db584f0bbf3$var$toggleMobileMenu(element) {
    const currentState = element.getAttribute("data-state");
    if (!currentState || currentState === "closed") $910e0db584f0bbf3$var$openModal();
    else $910e0db584f0bbf3$var$closeModal();
}
function $910e0db584f0bbf3$var$openModal() {
    $910e0db584f0bbf3$var$addClassAndListener();
}
function $910e0db584f0bbf3$var$closeModal() {
    $910e0db584f0bbf3$var$removeClassAndListener();
}
function $910e0db584f0bbf3$var$onOverlayClick(e) {
    if (e.currentTarget === e.target) $910e0db584f0bbf3$var$closeModal();
}
function $910e0db584f0bbf3$var$onEscPress(e) {
    if (e.code === "Escape") $910e0db584f0bbf3$var$closeModal();
}
function $910e0db584f0bbf3$var$openSlideSubmenu(e) {
    $910e0db584f0bbf3$var$activeSubmenu = e.target.closest(".mobile-nav-menu-item");
    if (!$910e0db584f0bbf3$var$activeSubmenu) return;
    $910e0db584f0bbf3$var$activeSubmenu.classList.add("active");
    $910e0db584f0bbf3$var$mobileMenuBackBtn.classList.add("active");
}
function $910e0db584f0bbf3$var$closeSlideSubmenu() {
    if (!$910e0db584f0bbf3$var$activeSubmenu) return;
    $910e0db584f0bbf3$var$activeSubmenu.classList.remove("active");
    $910e0db584f0bbf3$var$mobileMenuBackBtn.classList.remove("active");
}
$910e0db584f0bbf3$var$hamburgerBtn.addEventListener("click", ()=>{
    $910e0db584f0bbf3$var$toggleMobileMenu($910e0db584f0bbf3$var$hamburgerBtn);
});
function $910e0db584f0bbf3$var$addClassAndListener() {
    $910e0db584f0bbf3$var$mobileMenuOverlay.classList.add("active");
    $910e0db584f0bbf3$var$mobileMenu.classList.add("active");
    $910e0db584f0bbf3$var$body.classList.add("no-scroll");
    $910e0db584f0bbf3$var$classListToggler($910e0db584f0bbf3$var$hamburgerBtn, "active");
    $910e0db584f0bbf3$var$hamburgerBtn.setAttribute("data-state", "opened");
    $910e0db584f0bbf3$var$hamburgerBtn.setAttribute("aria-expanded", "true");
    $910e0db584f0bbf3$var$mobileMenuOverlay.addEventListener("click", $910e0db584f0bbf3$var$onOverlayClick);
    document.addEventListener("keydown", $910e0db584f0bbf3$var$onEscPress);
    $910e0db584f0bbf3$var$slideMenu.addEventListener("click", $910e0db584f0bbf3$var$openSlideSubmenu);
    $910e0db584f0bbf3$var$mobileMenuBackBtn.addEventListener("click", $910e0db584f0bbf3$var$closeSlideSubmenu);
    $910e0db584f0bbf3$var$mobileNavMenu.style.height = $910e0db584f0bbf3$var$mobileNavMenu.scrollHeight + "px";
}
function $910e0db584f0bbf3$var$removeClassAndListener() {
    $910e0db584f0bbf3$var$mobileMenuOverlay.classList.remove("active");
    $910e0db584f0bbf3$var$mobileMenu.classList.remove("active");
    $910e0db584f0bbf3$var$body.classList.remove("no-scroll");
    $910e0db584f0bbf3$var$classListToggler($910e0db584f0bbf3$var$hamburgerBtn, "active");
    $910e0db584f0bbf3$var$hamburgerBtn.setAttribute("data-state", "closed");
    $910e0db584f0bbf3$var$hamburgerBtn.setAttribute("aria-expanded", "false");
    $910e0db584f0bbf3$var$mobileMenuOverlay.removeEventListener("click", $910e0db584f0bbf3$var$onOverlayClick);
    document.removeEventListener("keydown", $910e0db584f0bbf3$var$onEscPress);
    $910e0db584f0bbf3$var$closeSlideSubmenu();
    $910e0db584f0bbf3$var$slideMenu.removeEventListener("click", $910e0db584f0bbf3$var$openSlideSubmenu);
    $910e0db584f0bbf3$var$mobileMenuBackBtn.removeEventListener("click", $910e0db584f0bbf3$var$closeSlideSubmenu);
}

});

parcelRegister("1tHxY", function(module, exports) {
const $113a4763f3b527ca$var$collapsibleMenu = document.querySelectorAll(".footer-menu");
$113a4763f3b527ca$var$collapsibleMenu.forEach((collapsibleSubMenu)=>{
    collapsibleSubMenu.addEventListener("click", (e)=>{
        const activeMenu = e.target.closest(".footer-menu-item");
        if (!activeMenu) return;
        $113a4763f3b527ca$var$toggleCollapsibleMenu(activeMenu);
    });
});
function $113a4763f3b527ca$var$toggleCollapsibleMenu(menuToActivate) {
    const activeMenu = menuToActivate.querySelector(".footer-menu-submenu-wrapper");
    menuToActivate.classList.toggle("active");
    if (activeMenu.style.maxHeight) activeMenu.style.maxHeight = null;
    else activeMenu.style.maxHeight = activeMenu.scrollHeight + "px";
}

});

parcelRegister("eVdBp", function(module, exports) {
const $add0f0b156e44235$var$overlay = document.querySelector(".overlay");
const $add0f0b156e44235$var$headerMenuItemServices = document.querySelector(".header-nav-menu-item-services");
const $add0f0b156e44235$var$headerMenuContainerServices = $add0f0b156e44235$var$headerMenuItemServices.querySelector(".header-menu-container-services");
const $add0f0b156e44235$var$headerMenuItemAboutUs = document.querySelector(".header-nav-menu-item-about-us");
const $add0f0b156e44235$var$headerMenuContainerAboutUs = $add0f0b156e44235$var$headerMenuItemAboutUs.querySelector(".header-menu-container-about-us");
const $add0f0b156e44235$var$headerNavMenuButtons = document.querySelectorAll(".header-nav-menu-btn");
const $add0f0b156e44235$var$headerNavMenuIcons = document.querySelectorAll(".header-nav-menu-icon");
$add0f0b156e44235$var$headerMenuItemServices.addEventListener("mouseenter", ()=>{
    $add0f0b156e44235$var$headerMenuItemServices.addEventListener("mouseleave", ()=>{
        $add0f0b156e44235$var$removeClassAndListener($add0f0b156e44235$var$headerMenuContainerServices);
    });
    $add0f0b156e44235$var$addClassAndListener($add0f0b156e44235$var$headerMenuContainerServices);
});
$add0f0b156e44235$var$headerMenuItemAboutUs.addEventListener("mouseenter", ()=>{
    $add0f0b156e44235$var$headerMenuItemAboutUs.addEventListener("mouseleave", ()=>{
        $add0f0b156e44235$var$removeClassAndListener($add0f0b156e44235$var$headerMenuContainerAboutUs);
    });
    $add0f0b156e44235$var$addClassAndListener($add0f0b156e44235$var$headerMenuContainerAboutUs);
});
function $add0f0b156e44235$var$addClassAndListener(activeHeaderMenuContainer) {
    $add0f0b156e44235$var$overlay.classList.add("active");
    activeHeaderMenuContainer.classList.add("active");
}
function $add0f0b156e44235$var$removeClassAndListener(activeHeaderMenuContainer) {
    $add0f0b156e44235$var$overlay.classList.remove("active");
    activeHeaderMenuContainer.classList.remove("active");
}

});

parcelRegister("8u5tz", function(module, exports) {
window.addEventListener("scroll", $0198162f73a273a6$var$onScrollEvent);
function $0198162f73a273a6$var$onScrollEvent() {
    const scroll = this.scrollY;
    if (scroll > 10) document.querySelector(".header").classList.add("shadow");
    else document.querySelector(".header").classList.remove("shadow");
}

});

parcelRegister("9irX0", function(module, exports) {
(()=>{
    const languageTogglerButton = document.querySelectorAll("[data-btn='language']");
    languageTogglerButton.forEach((button)=>{
        if (window.location.pathname === "/") {
            const newPathName = "/en/index";
            button.attributes.href.value = newPathName;
        } else if (window.location.pathname.includes("/en")) {
            const newPathName = window.location.pathname.replace("/en", "");
            button.attributes.href.value = newPathName;
        } else {
            const newPathName = `/en${window.location.pathname}`;
            button.attributes.href.value = newPathName;
        }
    });
})();

});

parcelRequire("cs7FV");
parcelRequire("1tHxY");
parcelRequire("eVdBp");
parcelRequire("8u5tz");
parcelRequire("9irX0");

})();
//# sourceMappingURL=how-to-invest-to-etf.f59641fe.js.map
